module.exports = __webpack_public_path__ + "img/unskippable.228318ef.svg";